import { Pipe, PipeTransform } from '@angular/core';
import { DocumentTypeGroupEnum } from '../../default-constants/document-type-settings.constants';

@Pipe({
  name: 'documentTypeSectionName',
  standalone: true
})
export class DocumentTypeSectionNamePipe implements PipeTransform {

    private fieldSectionTranslationKeys = {
      [DocumentTypeGroupEnum.TopSection]:'Document type setting - modal - document accordion title (Document type section) - Top Section',
      [DocumentTypeGroupEnum.DocumentField]:'Document type setting - modal - document accordion title (Document type section) - Document Fields',
      [DocumentTypeGroupEnum.Signature]:'Document type setting - modal - signature request accordion title (Document type section) - Signature Request',
      [DocumentTypeGroupEnum.Details]:'Document type setting - modal - Details accordion title (Document type section) - Details',
      [DocumentTypeGroupEnum.Document]:'Document type setting - modal - Document accordion title (Document type section) - Document',
    }


  transform(value: string): string {
    return Object.prototype.hasOwnProperty.call(this.fieldSectionTranslationKeys, value)? this.fieldSectionTranslationKeys[value as DocumentTypeGroupEnum] : value;
  }

}
